import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Lock, AlertCircle, ShieldCheck } from "lucide-react";
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "fw_admin_token";

const AdminGate = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  // 起動時：保存トークンを検証
  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    axios.get(`${API_BASE}/admin/verify`, { params: { token } })
      .then(r => {
        if (r.data?.valid) setAuthed(true);
        else localStorage.removeItem(TOKEN_KEY);
      })
      .catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const onSubmit = async () => {
    setError("");
    setBusy(true);
    try {
      const r = await axios.post(`${API_BASE}/admin/auth`, { password });
      localStorage.setItem(TOKEN_KEY, r.data.token);
      setAuthed(true);
    } catch (e) {
      setError(e.response?.data?.detail || "ログインに失敗しました");
    } finally {
      setBusy(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg-deep)" }}>
        <div className="text-xs" style={{ color: "var(--text-muted)" }}>読み込み中...</div>
      </div>
    );
  }

  if (authed) return children;

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "var(--bg-deep)" }} data-testid="admin-gate">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="panel-elevated p-8 max-w-md w-full"
      >
        <div className="text-center mb-6">
          <ShieldCheck size={32} className="mx-auto mb-3" style={{ color: "var(--gold)" }} />
          <h1 className="font-display text-2xl mb-1">編集サイト</h1>
          <p className="text-xs" style={{ color: "var(--text-muted)" }}>管理者専用</p>
        </div>

        <label className="block text-xs uppercase tracking-wider mb-2" style={{ color: "var(--text-muted)" }}>
          <Lock size={12} className="inline mr-1" /> 管理者パスワード
        </label>
        <input
          type="password"
          className="cinema mb-3"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && password && onSubmit()}
          placeholder="パスワードを入力"
          autoFocus
          data-testid="admin-password-input"
        />
        {error && (
          <p className="text-xs mb-3 flex items-center gap-1" style={{ color: "var(--red-warn)" }} data-testid="admin-error">
            <AlertCircle size={12} /> {error}
          </p>
        )}
        <button
          className="btn-gold w-full"
          onClick={onSubmit}
          disabled={!password || busy}
          data-testid="admin-submit"
        >
          {busy ? "確認中..." : "ログイン"}
        </button>

        <p className="text-[10px] mt-6 text-center" style={{ color: "var(--text-muted)" }}>
          このページは管理者専用です。<br />
          素材投稿は <a href="/upload" style={{ color: "var(--gold)" }}>こちら</a> から。
        </p>
      </motion.div>
    </div>
  );
};

export default AdminGate;
